module.exports = __webpack_public_path__ + "img/organizate-vecinos.1ceb95a6.png";